var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconMapMarker = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icon_-_map-marker",
    "data-name": "Icon - map-marker",
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.152,
    height: 20,
    viewBox: "0 0 15.152 20",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "location-dot-light",
    d: "M10.732,7.519A3.157,3.157,0,1,1,7.576,4.386,3.144,3.144,0,0,1,10.732,7.519ZM7.576,9.4a1.88,1.88,0,1,0-1.894-1.88A1.887,1.887,0,0,0,7.576,9.4Zm7.576-1.88c0,3.423-4.616,9.517-6.641,12.031a1.2,1.2,0,0,1-1.87,0C4.581,17.036,0,10.942,0,7.519a7.576,7.576,0,0,1,15.152,0ZM7.576,1.253A6.288,6.288,0,0,0,1.263,7.519,6.832,6.832,0,0,0,1.916,10a24.2,24.2,0,0,0,1.72,3.215A58.582,58.582,0,0,0,7.576,18.7a58.849,58.849,0,0,0,3.942-5.487A24.3,24.3,0,0,0,13.234,10a6.784,6.784,0,0,0,.655-2.483A6.288,6.288,0,0,0,7.576,1.253Z",
    fill: "#303030"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconMapMarker);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Icon - map-marker.000887b1056d7d84e521b9e6df3bbf53.svg";